import { type Metric } from '../vessel_data'

export enum FwdTrusterMetric {
  thrusterForwardPort = 'thrusterForwardPort',
  thrusterForwardStbd = 'thrusterForwardStbd'
}

export enum AftThrusterMetric {
  thrusterAftPort = 'thrusterAftPort',
  thrusterAftStbd = 'thrusterAftStbd',
}

export type ThrusterMetricName = (keyof typeof FwdTrusterMetric) | (keyof typeof AftThrusterMetric)

export type ThrusterMetrics = Record<ThrusterMetricName, Metric>

export const allThrusterFwdMetricNames: ThrusterMetricName[] = Object.values(FwdTrusterMetric)

export const allThrusterAftMetricNames: ThrusterMetricName[] = Object.values(AftThrusterMetric)

export const allThrusterMetricNames = allThrusterFwdMetricNames.concat(allThrusterAftMetricNames)
